import api, { ApiResponse } from '../core/api';

export interface Settlement {
  _id: string;
  module: string;
  resourceType: string;
  resourceNumber: string;
  partnerType: string;
  partnerId: { _id?: string; firstName?: string; lastName?: string; email?: string; phone?: string } | string | null;
  /** Business name for merchants, otherwise the partner's name / phone / short id. */
  payeeName?: string;
  payeeContact?: string;
  grossAmount: number;
  commissionAmount: number;
  commissionPercent?: number;
  payoutAmount: number;
  status: 'pending' | 'processing' | 'paid' | 'failed' | 'on_hold' | 'settled';
  failureReason?: string;
  holdReason?: string;
  promoCode?: string;
  settledAt?: string;
  createdAt: string;
  /** holdUntil: end of the Payout Hold (Site Settings → Payments). */
  metadata?: { holdUntil?: string; holdReleasedAt?: string };
}

export interface SettlementSummaryItem {
  _id: string;
  count: number;
  totalPayout: number;
  totalCommission: number;
  totalGross?: number;
  settled?: number;
  pending?: number;
  failed?: number;
  onHold?: number;
  settledPayout?: number;
  pendingPayout?: number;
  failedPayout?: number;
  onHoldPayout?: number;
}

export interface SettlementSummaryResponse {
  byStatus: SettlementSummaryItem[];
  byModule: SettlementSummaryItem[];
  totals?: { count: number; totalPayout: number; totalCommission: number };
}

export interface SettlementListTotals {
  count: number;
  gross: number;
  commission: number;
  payout: number;
}

export interface SettlementDateParams {
  from?: string;
  to?: string;
  timezone?: string;
}

export async function getSettlements(params?: SettlementDateParams & {
  status?: string;
  module?: string;
  search?: string;
  page?: number;
  limit?: number;
}) {
  const res = await api.get<ApiResponse<Settlement[]> & { meta?: { total: number; totals?: SettlementListTotals } }>(
    '/settlements',
    { params },
  );
  return res.data;
}

export async function getSettlementSummary(params?: SettlementDateParams) {
  const res = await api.get<ApiResponse<SettlementSummaryResponse | SettlementSummaryItem[]>>('/settlements/summary', { params });
  const data = res.data.data;
  if (Array.isArray(data)) {
    return { byStatus: data, byModule: [] } as SettlementSummaryResponse;
  }
  return data as SettlementSummaryResponse;
}

export async function retrySettlement(id: string) {
  const res = await api.post(`/settlements/${id}/retry`);
  return res.data;
}
